<div
  class="pill-container d-flex flex-row flex-wrap"
  cdkDropList
  cdkDropListOrientation="mixed"
  (cdkDropListDropped)="drop($event)"
  [cdkDropListDisabled]="!isDragActive"
>
  <div *ngFor="let competency of competencies" cdkDrag>
    <app-competency-pill
      *cdkDragPreview
      class="custom-preview"
      [commands]="commands"
      [competency]="competency"
    ></app-competency-pill>
    <app-competency-pill
      [commands]="commands"
      [competency]="competency"
    ></app-competency-pill>
  </div>
  <app-new-competency-pill
    *ngIf="isAddPillButtonActive"
    [isAddDisabled]="isAddDisabled"
    [competencies]="getUnselectedCompetencies()"
    [employeeCompetencies]="employeeCompetencies"
    (newCompetencyEvent)="setNewCompetency($event)"
  ></app-new-competency-pill>
  <button
    *ngIf="isAddPillButtonActive"
    [disabled]="isAddDisabled"
    ngbTooltip="{{
      'competency.competency_add_modal.add_all_matching_competencies'
        | translate
    }}"
    class="add-all-matching-button d-flex justify-content-center align-items-center align-self-center"
    (click)="setAllMatchingCompetencies()">
    <fa-icon [icon]="['fas', 'link']"></fa-icon>
  </button>
</div>
